import styled from "styled-components";


export const Wrapper = styled.div`
  margin: 50px 50px 50px 50px;
`;

export const ContainerPrivacyPolicy = styled.div`
/* background: ${({ theme }) => theme.color.dragonOrange} ; */
background: #fff9ff;
  max-width: 1050px;
  margin: auto;
  min-width: 280px;
  border-radius: 20px;
  padding: 50px;
  @media (max-width: ${({ theme }) => theme.breakpoint.maxContentSize}px) {
    width: 100%;
  }
  margin-top: ${({ isModal }) => (isModal ? "10px" : "130px")};
  margin-bottom: 230px;
  /* box-shadow: 10px 10px 10px rgba(9, 10, 51, 0.05),
    0px 16px 58px rgba(9, 10, 51, 0.05); */
    box-shadow: 0px 0px 5px 5px rgba(9, 10, 51, 0.05),
    0px 16px 58px rgba(9, 10, 51, 0.05);
     @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
   font-size: 12px;
    padding: 30px;
      margin-top: ${({ isModal }) => (isModal ? "10px" : "160px")};
  margin-bottom: 100px;
  width: 100%;
  border-radius: 10px;
  margin-left: 0;
  margin-right: 0;
  
  /* Dodatkowe style dla modalu na mobilnych */
  ${({ isModal }) => isModal && `
    margin: 0;
    border-radius: 10px;
    box-shadow: none;
  `}
  }
   @media (max-width: ${({ theme }) => theme.breakpoint.miniMobile}px) {
    padding: 17px;
  }
  
  
`;